import LabeledTextField from '@common/ui/LabeledTextField';
import { Alert } from '@mui/material';

interface DurationComboboxProps {
  onChange: (value: string) => void;
  disable: boolean;
  errorMessage: string | null;
}
export function DurationCombobox({ onChange, disable, errorMessage }: DurationComboboxProps) {
  return (
    <>
      <LabeledTextField
        label="Duration (in Hours)"
        placeholder="Enter a number"
        type="number"
        inputProps={{ 'aria-valuemin': 0, pattern: '[0-9]*', min: 0, step: 0.5 }}
        onChange={(val) => onChange(val.target.value)}
        disabled={disable}
      />
      {errorMessage ? (
        <Alert severity="warning" variant="outlined">
          {errorMessage}
        </Alert>
      ) : null}
    </>
  );
}
